import { Zap } from "lucide-react";
import { cn } from "@/lib/utils";

interface LogoProps {
  collapsed?: boolean;
  className?: string;
}

export function Logo({ collapsed, className }: LogoProps) {
  return (
    <div className={cn("flex items-center gap-2.5", className)}>
      <div className="relative flex h-9 w-9 shrink-0 items-center justify-center rounded-xl bg-gradient-to-br from-primary to-indigo-400 shadow-lg shadow-primary/25">
        <Zap className="h-5 w-5 text-white" fill="currentColor" />
        <div className="absolute inset-0 rounded-xl bg-gradient-to-br from-white/20 to-transparent" />
      </div>
      {!collapsed && (
        <div className="flex flex-col">
          <span className="text-lg font-bold leading-tight tracking-tight text-foreground">
            Dispara
          </span>
          <span className="text-[10px] font-medium leading-tight tracking-wider text-muted-foreground uppercase">
            v3.0
          </span>
        </div>
      )}
    </div>
  );
}
